import axios from 'axios';
import { Company, CompanyFilter, CompanyListResponse, CompanyFormData } from '../types/company';

const API_URL = '/api/companies';

export class CompanyService {

  async getAll(filters: CompanyFilter = {}): Promise<CompanyListResponse> {
    try {
      // Remover filtros vazios ou 'Todos' para não enviar na query
      const params: any = {};
      if (filters.name) params.name = filters.name;
      if (filters.cnpj) params.cnpj = filters.cnpj;
      if (filters.active !== undefined && filters.active !== 'Todos') {
        params.active = filters.active === 'true' || filters.active === true;
      }
      if (filters.page) params.page = filters.page;
      if (filters.pageSize) params.pageSize = filters.pageSize;
      if (filters.sortField) params.sortField = filters.sortField;
      if (filters.sortOrder) params.sortOrder = filters.sortOrder;

      console.log("[CompanyService.getAll] Enviando filtros:", params);
      const response = await axios.get<CompanyListResponse>(API_URL, { params });
      console.log("[CompanyService.getAll] Resposta recebida:", response.data);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
      // Lançar o erro para que a página possa tratá-lo
      throw new Error('Falha ao buscar dados das empresas.');
    }
  }

  async getById(id: number): Promise<Company> {
    try {
      const response = await axios.get<Company>(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar empresa com ID ${id}:`, error);
      throw new Error('Falha ao buscar dados da empresa.');
    }
  }

  async create(companyData: CompanyFormData): Promise<Company> {
    try {
      const response = await axios.post<Company>(API_URL, companyData);
      return response.data;
    } catch (error: any) {
      console.error("Erro ao criar empresa:", error);
      // Lançar erro com mensagem da API, se disponível
      throw new Error(error.response?.data?.error || 'Falha ao criar empresa.');
    }
  }

  async update(id: number, companyData: CompanyFormData): Promise<Company> {
    try {
      const response = await axios.put<Company>(`${API_URL}/${id}`, companyData);
      return response.data;
    } catch (error: any) {
      console.error(`Erro ao atualizar empresa com ID ${id}:`, error);
      throw new Error(error.response?.data?.error || 'Falha ao atualizar empresa.');
    }
  }

  async delete(id: number): Promise<void> { // Pode retornar algo se a API retornar
    try {
      await axios.delete(`${API_URL}/${id}`);
    } catch (error: any) {
      console.error(`Erro ao excluir empresa com ID ${id}:`, error);
      throw new Error(error.response?.data?.error || 'Falha ao excluir empresa.');
    }
  }

  // --- Adicionar métodos getById, create, update, delete posteriormente --- 

} 